// Vue 3: Use createI18n instead of new VueI18n
import { createI18n } from "vue-i18n"

// `pnpm translate` (index.ts) locales/*.json fayllarini har build da umumiy
// Google Sheet dan qayta yozadi. Sheet XB bilan bitta, shuning uchun Turon ga
// xos matnlar u yerda emas, shu yerda — yuklash paytida — qo'llanadi.
// Yangi Turon matni kerak bo'lsa overrides/<locale>.json ga qo'shing.

// Sheet da "iABS" / "IABS" deb yozilgan, Turon da esa oddiy "ABS" ko'rinishi
// kerak. Sheet ni o'zgartirib bo'lmaydi — u XB ga ham tegishli.
function applyTuronText(value) {
  if (typeof value === "string")
    return value.replace(/[iI]ABS/g, "ABS")
  if (Array.isArray(value))
    return value.map(applyTuronText)
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, applyTuronText(v)]),
    )
  }
  return value
}

function loadLocaleMessages() {
  const locales = import.meta.glob("./locales/*.json", { eager: true })
  const overrides = import.meta.glob("./overrides/*.json", { eager: true })
  const messages = {}

  Object.keys(locales).forEach((key) => {
    const matched = key.match(/\.\/locales\/([\w-]+)\.json$/i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      const base = locales[key].default || locales[key]
      messages[locale] = applyTuronText(base)
    }
  })

  Object.keys(overrides).forEach((key) => {
    const matched = key.match(/\.\/overrides\/([\w-]+)\.json$/i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      const extra = overrides[key].default || overrides[key]
      messages[locale] = { ...(messages[locale] || {}), ...extra }
    }
  })

  return messages
}

// Vue 3: Use createI18n with legacy: true for $t() compatibility
export default createI18n({
  legacy: false, // Important: enables Vue 2 style $t() usage in templates
  locale: localStorage.getItem("locale") || "ru",
  fallbackLocale: "ru",
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
  silentFallbackWarn: true,
})

// Export SUPPORT_LOCALES for use in other files
export const SUPPORT_LOCALES = ["ru", "uz-cyrl", "uz-latn", "en"]
